const PANTRY_PRESETS = [
  {
    id: 'basic',
    name: 'Basic Pantry',
    description: 'The 20 essentials every kitchen needs',
    emoji: '🏠',
    items: [
      'Salt', 'Black Pepper', 'Olive Oil', 'Butter', 'Eggs',
      'All-Purpose Flour', 'Granulated Sugar', 'Onion', 'Garlic',
      'White Rice', 'Spaghetti', 'Canned Tomatoes', 'Broth (chicken)',
      'Soy Sauce', 'Baking Powder', 'Baking Soda', 'Honey',
      'Apple Cider Vinegar', 'Paprika', 'Garlic Powder',
    ],
  },
  {
    id: 'healthy',
    name: 'Healthy Eater',
    description: 'Clean proteins, whole grains, fresh produce',
    emoji: '🥗',
    items: [
      'Chicken Breast', 'Salmon Fillet', 'Eggs', 'Greek Yogurt',
      'Quinoa', 'Brown Rice', 'Rolled Oats', 'Spinach',
      'Broccoli', 'Sweet Potato', 'Tomato', 'Avocado',
      'Almonds', 'Chia Seeds', 'Olive Oil', 'Lemon',
      'Garlic', 'Black Beans (canned)',
    ],
  },
  {
    id: 'italian',
    name: 'Italian Kitchen',
    description: 'Pasta nights and Sunday sauces',
    emoji: '🍝',
    items: [
      'Spaghetti', 'Penne', 'Rigatoni', 'Canned Tomatoes',
      'Tomato Paste', 'Extra Virgin Olive Oil', 'Parmesan',
      'Mozzarella', 'Garlic', 'Basil', 'Oregano (dried)',
      'Prosciutto', 'Pancetta', 'Balsamic Vinegar', 'Red Wine Vinegar',
    ],
  },
  {
    id: 'asian',
    name: 'Asian Pantry',
    description: 'Stir-fries, noodles and bold sauces',
    emoji: '🥢',
    items: [
      'White Rice', 'Jasmine Rice', 'Rice Noodles', 'Soba Noodles',
      'Soy Sauce', 'Sesame Oil', 'Fish Sauce', 'Oyster Sauce',
      'Hoisin Sauce', 'Ginger', 'Garlic', 'Scallion',
      'Rice Vinegar', 'Mirin', 'Gochujang', 'Sesame Seeds',
    ],
  },
  {
    id: 'mealprep',
    name: 'Meal Prep',
    description: 'High-protein batch cooking essentials',
    emoji: '💪',
    items: [
      'Chicken Breast', 'Ground Turkey', 'Eggs', 'Greek Yogurt',
      'White Rice', 'Quinoa', 'Broccoli', 'Spinach',
      'Sweet Potato', 'Olive Oil', 'Black Beans (canned)',
      'Garlic', 'Salt', 'Black Pepper',
    ],
  },
];

export default PANTRY_PRESETS;
